/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `0` - Other issues
 * * `1000` - Hardware does not support Intel® VT-x virtualization extensions
 * * `1001` - Intel® VT-x virtualization extensions are disabled in system BIOS
 * * `1002` - Hardware does not support Intel® EPT virtualization extensions
 * * `1003` - Hardware does not support PAE
 * * `1004` - PAE disabled in the BIOS
 * * `1005` - HP Sure Click cannot run while Hyper-V is enabled
 * * `1006` - Hyper-V (Virtualization Based Security/Device Guard/Credential Guard) is enabled via Group Policy Object
 * * `1007` - Critical Windows update missing: KB3033929
 * * `1008` - Unable to support Hyper-V on this device
 * * `1009` - Require UEFI boot in order to support Hyper-V
 * * `1010` - Require Windows 10 or later in order to support Hyper-V
 * * `1011` - This CPU is not supported when Hyper-V is enabled
 * * `1012` - Require Secure Boot third party key in order to support Hyper-V
 * * `1013` - Require CPU capable of VMCS shadowing in order to support Hyper-V
 * * `1015` - Unable to support the requested hypervisor configuration on this device
 * * `1016` - Installation has been corrupted and needs to be repaired
 * * `2000` - An internal error is present
 * * `2001` - Insufficient disk space
 * * `2002` - HP Sure Click is not licensed
 * * `2003` - Volume Snapshot Service (VSS) is disabled
 * * `2004` - Incompatible virtualization software installed (VirtualBox)
 * * `2005` - Awaiting pending reboot for Windows Update
 * * `2006` - Windows Update is in progress
 * * `2007` - Another user is logged in and using HP Sure Click on the same computer
 * * `2008` - Insufficient free memory available
 * * `2009` - Background creation of updated template blocked
 * * `2010` - Micro-VM loading failed
 * * `2011` - Endpoint requires a reboot to protect the system
 * * `2012` - The VBA component must be installed with Microsoft Office
 * * `2013` - Required Windows Updates are not installed
 * * `2014` - No supported Windows language pack is installed
 * * `2015` - Windows 8.1 Update KB2919355 needs to be reapplied
 * * `2016` - Microsoft Software Shadow Copy Provider service is disabled
 * * `2017` - The user's Windows display language is not supported
 * * `2019` - Unsupported AMD CPU family
 * * `2020` - HP Sure Click license will expire soon
 * * `2021` - Failed to fetch policy from Controller
 * * `2022` - Unsupported configuration
 * * `2023` - Unsupported CPU for HP Sure Click
 * * `3000` - System template creation has failed
 * * `3001` - User-specific template creation has failed
 * * `3002` - An attempt to create a system template was canceled
 * * `3003` - An attempt to create a user-specific template was canceled
 * * `3004` - Waiting for a critical initialization to occur
 * * `3005` - Waiting for a deferred initialization to occur
 * * `3006` - Memory requirements have not been met
 * * `3007` - IE 11 update required to safely support Enterprise Mode (KB2956283 or MS14-035)
 * * `3008` - Enhanced Protected Mode must be turned off
 * * `3009` - Google Chrome Frame must be uninstalled
 * * `3010` - Endpoint requires a reboot for an upgrade to take effect
 * * `3012` - No supported Office UI language pack is installed
 * * `3013` - Unable to create a template; Office is not activated. To protect this device, disable Document Protection or activate Office
 * * `3014` - Isolation is not supported on the current Windows version
 * * `3015` - Misconfiguration: Intranet/SaaS lists ignored
 * * `3016` - Failed to enable support for Hyper-V
 * * `3017` - Micro-virtualization blocked while enabling support for Hyper-V
 * * `3018` - The last attempt to contact the HP Threat Intelligence Service was unsuccessful
 * * `3019` - BitLocker must be suspended before the computer is shutdown/restarted
 * * `3020` - Test boot failed when enabling support for Hyper-V
 * * `3021` - Unable to configure the UEFI boot order when enabling support for Hyper-V
 * * `3022` - Unable to determine the boot device when enabling support for Hyper-V
 * * `3024` - Secure Browsing Extension encountered an error
 * * `3025` - HP Sure Click Outlook Add-in is disabled
 * * `3026` - "Add properties to attachments to enable Reply with Changes" is enabled in Outlook
 * * `3027` - Corrupted local group policy folder detected
 * * `3028` - Some printer drivers are unusable. These printers will not be available to secure browsers or files
 * * `3029` - HP Sure Click has not been added to the Windows Defender exclusions
 * * `3030` - Application has failed to virtualize and will not be available: Adobe Reader
 * * `3031` - Application has failed to virtualize and will not be available: Adobe Acrobat
 * * `3032` - Application has failed to virtualize and will not be available: Microsoft Word
 * * `3033` - Application has failed to virtualize and will not be available: Microsoft Excel
 * * `3034` - Application has failed to virtualize and will not be available: Microsoft PowerPoint
 * * `3035` - Application has failed to virtualize and will not be available: Microsoft Internet Explorer
 * * `3036` - Application has failed to virtualize and will not be available: Chromium
 * * `3037` - Application has failed to virtualize and will not be available: Mozilla Firefox
 * * `3038` - Microsoft Office will not be available because it is unlicensed
 * * `3039` - Web links are being opened in an unprotected default browser
 * * `3040` - No supported Microsoft Office languages are installed, Microsoft Office will not be available
 * * `3041` - Stored and applied policy do not match
 * * `3042` - The default browser is not supported by HP Credential Protection
 * * `3043` - Outlook add-in has not been added to the list of add-ins that are always enabled on the endpoint
 * * `3044` - Printer drivers failed to install into template
 * * `4000` - Sure Sense is not active because base rules failed to load
 * * `4001` - Sure Sense is not active due to an excessive backlog of alerts
 * * `4002` - Sure Sense is not active because the service failed to start
 * * `4003` - Monitoring is not active because rules failed to load
 * * `4004` - Indexing has not completed in the given time frame
 * * `4005` - Monitoring hooking disabled on Windows version
 * * `4006` - Indexing has stopped because it has exceeded the limit for staged indexing. Check the file types being indexed or increase the staged indexing limit.
 * * `4007` - Sure Sense is ignoring base rules from a previous version
 * * `4008` - Sure Sense Malware Prevention is not active on this device as the Windows version is not supported
 * * `4009` - Sure Sense Behavioral Detection is not active on this device as the Windows version is not supported
 * * `5000` - Sure Sense has an internal error
 * * `5001` - Sure Sense is unlicensed
 * * `5002` - Sure Sense failed to download malware definitions
 * @export
 */
export const ManagementActionType = {
    UNKNOWN: 0,
    VTX_NOT_CAPABLE: 1000,
    VTX_NOT_ENABLED: 1001,
    EPT_DISABLED: 1002,
    PAE_NOT_SUPPORTED: 1003,
    PAE_DISABLED: 1004,
    HYPER_V_ENABLED: 1005,
    HYPER_V_ENABLED_VIA_GPO: 1006,
    KB3033929: 1007,
    AX_REQUIRED_BUT_NOT_SUPPORTED: 1008,
    AX_REQUIRED_BUT_MISSING_EFI: 1009,
    AX_REQUIRED_BUT_MISSING_WIN_10: 1010,
    AX_REQUIRED_BUT_MISSING_SUPPORTED_CPU: 1011,
    AX_REQUIRED_BUT_MISSING_SECURE_BOOT_SIGNATURE: 1012,
    AX_REQUIRED_BUT_MISSING_VMSC_SHADOW: 1013,
    HV_PROFILE_NOT_SUPPORTED: 1015,
    CORRUPT_INSTALLATION: 1016,
    INTERNAL_ERROR: 2000,
    NOT_ENOUGH_DISK: 2001,
    UNLICENSED: 2002,
    VSS_SERVICE_DISABLED: 2003,
    VBOX_ALREADY_INSTALLED: 2004,
    WINDOWSUPDATE_REBOOT_PENDING: 2005,
    WINDOWSUPDATE_IN_PROGRESS: 2006,
    ACTIVE_IN_ANOTHER_SESSION: 2007,
    NOT_ENOUGH_FREE_MEMORY: 2008,
    BACKGROUND_TEMPLATE_BLOCKED: 2009,
    MICROVM_LOAD_ERROR: 2010,
    VSENTRY_REBOOT_PENDING: 2011,
    VBA_MISSING: 2012,
    WINDOWS_UPDATES_MISSING: 2013,
    LANGUAGE_PACK_MISSING: 2014,
    MUI_MISMATCH: 2015,
    MS_SSCP_NOT_ENABLED: 2016,
    UNSUPPORTED_USER_LANGUAGE: 2017,
    UNSUPPORTED_AMD_CPU: 2019,
    LICENSE_EXPIRY: 2020,
    POLICY_NOT_APPLIED: 2021,
    UNSUPPORTED_CONFIGURATION: 2022,
    UNSUPPORTED_SURE_CLICK_CPU: 2023,
    TEMPLATE_CREATION_FAILED: 3000,
    USER_IMAGE_CREATION_FAILED: 3001,
    TEMPLATE_CREATION_CANCELLED: 3002,
    USER_IMAGE_CREATION_CANCELLED: 3003,
    CRITICAL_TEMPLATE_PENDING: 3004,
    DEFERRED_TEMPLATE_PENDING: 3005,
    NOT_ENOUGH_MEMORY: 3006,
    EMIE_PATCH_REQUIRED: 3007,
    EPM_ENABLED: 3008,
    CHROME_FRAME_INSTALLED: 3009,
    VSENTRY_UPGRADE_AWAITING_REBOOT: 3010,
    OFFICE_UI_LANG_PACK_MISSING: 3012,
    OFFICE_NOT_ACTIVATED: 3013,
    INCOMPATIBLE_WINDOWS_VERSION: 3014,
    MISCONFIGURED_CONTAINMENT: 3015,
    ERROR_INSTALLING_AX: 3016,
    UXEN_BLOCKED_BY_AX: 3017,
    THREAT_CLOUD_INACCESSIBLE: 3018,
    SUSPEND_BIT_LOCKER: 3019,
    ERROR_AX_TEST_BOOT_FAIL: 3020,
    ERROR_AX_FAST_BOOT_BUG: 3021,
    ERROR_AX_BCD_BOOT_FAIL: 3022,
    SBX_STATE_HAS_ERROR: 3024,
    OUTLOOK_ADDIN_DISABLED: 3025,
    OUTLOOK_REPLY_WITH_CHANGES_ENABLED: 3026,
    SBX_FORCE_INSTALL_FAILURE: 3027,
    CRASHING_PRINTERS: 3028,
    WINDOWS_DEFENDER_EXCLUSIONS: 3029,
    FAILED_TO_VIRTUALIZE_ADOBE_READER: 3030,
    FAILED_TO_VIRTUALIZE_ADOBE_ACROBAT: 3031,
    FAILED_TO_VIRTUALIZE_MS_WORD: 3032,
    FAILED_TO_VIRTUALIZE_MS_EXCEL: 3033,
    FAILED_TO_VIRTUALIZE_MS_POWERPOINT: 3034,
    FAILED_TO_VIRTUALIZE_MS_INTERNET_EXPLORER: 3035,
    FAILED_TO_VIRTUALIZE_CHROMIUM: 3036,
    FAILED_TO_VIRTUALIZE_MOZILLA_FIREFOX: 3037,
    UNLICENSED_MS_OFFICE: 3038,
    SBX_UNPROTECTED_DEFAULT_BROWSER: 3039,
    NO_SUPPORTED_OFFICE_LANGUAGES: 3040,
    POLICY_TAMPERING: 3041,
    IDENTITY_PROTECTION_UNSUPPORTED_DEFAULT_BROWSER: 3042,
    FAILED_TO_WRITE_OUTLOOK_ADDIN_GPO: 3043,
    FAILED_TO_INSTALL_PRINTER_DRIVERS: 3044,
    RULES_FAILED_TO_LOAD: 4000,
    MONITORING_DISABLED_DUE_EXCESS_ALERTS: 4001,
    MONITORING_SERVICE_FAILED_TO_START: 4002,
    BASE_RULES_FAILED_TO_LOAD: 4003,
    INDEXING_HAS_NOT_COMPLETED_IN_TIME: 4004,
    HOOKING_DISABLED_WINDOWS_VERSION: 4005,
    STAGED_SEARCH_FILE_LIMIT_REACHED: 4006,
    BEM_ACTION_IGNORING_OLDER_RULES: 4007,
    BEM_ACTION_BEMK_DISABLED_WINDOWS_VERSION: 4008,
    BEM_ACTION_SURE_SENSE_ATC_DISABLED_WINDOWS_VERSION: 4009,
    SURE_SENSE_GENERIC_ERROR: 5000,
    SURE_SENSE_UNLICENSED: 5001,
    SURE_SENSE_DOWNLOAD_FAILED: 5002
} as const;
export type ManagementActionType = typeof ManagementActionType[keyof typeof ManagementActionType];


export function ManagementActionTypeFromJSON(json: any): ManagementActionType {
    return ManagementActionTypeFromJSONTyped(json, false);
}

export function ManagementActionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagementActionType {
    return json as ManagementActionType;
}

export function ManagementActionTypeToJSON(value?: ManagementActionType | null): any {
    return value as any;
}

